



























































































































































































import {
  MediaItem,
  Statement,
  Submission,
  Work,
} from "@/api/models";
import { SiteState, SubmissionState } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { bus } from "@/main";
import FigureWidget from "./widgets/FigureWidget.vue";
import MultiMediaPlayer from "./widgets/MultiMediaPlayer.vue";
import PdfFrame from "./widgets/PdfFrame.vue";
import ModelFrame from "./widgets/ModelFrame.vue";
import LinkSet from "./widgets/LinkSet.vue";
import DisplayOptionView from "./widgets/DisplayOptionView.vue";
import { backend, previewBaseUrl, statements } from "../.config";
import { publishSubmission } from "@/api/methods";
import { notEmptyString } from "@/api/validators";
import { formatDate } from "@/api/helpers";
import FilterSet from "@/api/filter-set";

@Component({
  name: "Overview",
  components: {
    FigureWidget,
    MultiMediaPlayer,
    LinkSet,
    PdfFrame,
    ModelFrame,
    DisplayOptionView
  },
  filters: FilterSet,
})
export default class Overview extends Vue {
  @Prop({ default: true}) mayEdit: boolean;
  @State("site") site: SiteState;
  @State("submission") submission: SubmissionState;
  @Action("assignSubmission", { namespace: "submission" })
  assignSubmission: Function;
  get works() {
    return this.submission.works;
  }

  get statements() {
    return this.submission.statements.filter((st) =>
      statements.map((s) => s.type).includes(st.type)
    );
  }

  get hasStatements() {
    return this.statements.length > 0;
  }

  get numWorks() {
    return this.works.length;
  }

  get wrapperClasses() {
    const cls = [["num-works", this.numWorks].join("-")];
    return cls;
  }

  findStatement(type: string) {
    return this.submission instanceof Submission
      ? this.submission.findStatement(type)
      : new Statement();
  }

  get statementItems() {
    const items = [];
    if (this.submission instanceof Submission) {
      statements.map((st) => {
        const statement = this.findStatement(st.type);
        if (statement instanceof Object) {
          items.push(statement);
        }
      });
    }
    return items;
  }

  get completionSubmitLabel() {
    const subkey = this.submission.submitted ? "resubmit" : "submit";
    return this.site.label("completion__" + subkey);
  }

  get lastSavedOn() {
    return [
      this.site.label("completion__last_saved_on"),
      formatDate(this.submission.modifiedAt, "dd/MM/yyyy HH:mm"),
    ].join(": ");
  }

  get isSubmitted() {
    return this.submission.submitted && this.submission.works.length > 0;
  }

  get publishedUrl() {
    const base = this.site.settings.get('preview_base_url');
    const baseUrl = notEmptyString(base, 8)? base : previewBaseUrl;
    return [baseUrl, this.submission.slug].join('/');
  }

  get qrCodePath() {
    const randNum = Math.floor(Math.random() * 999);
    return [backend.api, 'submission', 'qr-code', this.submission.slug].join('/') + '.svg?r=' + randNum;
  }

  get qrCodeWrapperClass() {
    return this.submission.showQrCode ? 'has-qr-code' : 'no-qr-code';
  }

  goTo(section: string, workId = "", index = 0) {
    const parts = [section];
    if (notEmptyString(workId)) {
      parts.push(workId);
      parts.push(index.toString());
    }
    const key = parts.join("-");
    bus.$emit("goto", key);
  }

  viewPublished() {
    window.open(this.publishedUrl, '_blank');
  }

  statementImageLabel(key: string) {
    const item = statements.find((s) => s.type === key);
    return item instanceof Object ? item.imagePrompt : key.replace(/_+/g, " ");
  }

  statementLabel(key: string) {
    const item = statements.find((s) => s.type === key);
    return item instanceof Object? item.prompt : key.replace(/_+/g, " ");
  }

  workClasses(work: Work) {
    return work.hasMediaItems ? ['has-media'] : ['no-media'];
  }

  mediaClasses(item: MediaItem) {
    return [item.provider, item.type];
  }

  statementClasses(statement: Statement): string[] {
    switch (statement.type) {
      case 'biography':
        return ['featured', 'landscape'];
      case 'where_am_i':
        return ['half', 'portrait'];
      default:
        return ['half'];
    }
  }

  matchStatementImageSize(statement: Statement) {
    switch (statement.type) {
      case 'biography':
        return 'featured';
      default:
        return 'thumb';
    }
  }

  publish() {
    if (this.mayEdit) {
      publishSubmission(this.submission._id).then((data) => {
        if (data.valid) {
          bus.$emit("published", true);
          bus.$emit('active', true);
          this.submission.submitted = true;
          if (data.modifiedAt) {
            this.submission.modifiedAt = new Date(data.modifiedAt);
          }
          this.assignSubmission(this.submission);
          this.$ls.set("submission", this.submission);
        }
      });
    }
  }
}
